<template>
	<div>
		<b-card>
			<template #header>
				<div class="card-header-title mt-1"><h5>{{ $t('air_cafe.category') }}</h5></div>
				<div class="card-header-actions">
					<b-input-group>
						<template #append>
							<b-input-group-text><strong class="fa fa-search"/></b-input-group-text>
							<b-button @click="createForm" variant="outline-primary" size="sm" class="mr-2 ml-3" style="font-size: 14px"><i class="fa fa-plus-circle"/></b-button>
						</template>
						<b-form-input v-model="search"/>
					</b-input-group>
				</div>
			</template>
			<b-overlay :show="loading" rounded="sm">
				<table class="table table-bordered table-hover">
					<thead>
					<tr>
						<th class="text-center">{{ '№' }}</th>
						<th class="text-center">{{ $t('air_cafe.icon') }}</th>
						<th class="text-center">{{ $t('air_cafe.name_uz') }}</th>
						<th class="text-center">{{ $t('air_cafe.name_ru') }}</th>
						<th class="text-center">{{ $t('air_cafe.name_en') }}</th>
						<th class="text-center">{{ $t('sale.status') }}</th>
						<th class="text-center">{{ $t('goods.actions') }}</th>
					</tr>
					</thead>
					<tbody v-if="items.length > 0">
					<tr v-for="(item, index) in items" :key="`group-${index}`">
						<td class="text-center pt-2">{{ index + 1 }}</td>
						<td class="text-center pt-2">{{ item.icon }}</td>
						<td class="text-center pt-2">{{ item.nameUz }}</td>
						<td class="text-center pt-2">{{ item.nameRu }}</td>
						<td class="text-center pt-2">{{ item.nameEn }}</td>
						<td class="text-center pt-2"><b-checkbox v-model="item.status" @change="changeStatus(item)" style="z-index: 1000000" switch/></td>
						<td class="text-center" style="width: 10%">
							<b-button @click="editForm(item)" variant="outline-primary" size="sm" class="fa fa-pencil"/>
						</td>
					</tr>
					</tbody>
					<tbody v-else>
					<tr>
						<td class="text-center p-3" colspan="7">{{ $t('empty') }}</td>
					</tr>
					</tbody>
				</table>
			</b-overlay>
		</b-card>

		<!--		Create / Edit		-->
		<b-modal v-model="createModal" :title="create ? $t('incomes.create.create') : $t('booking.edit')" centered no-close-on-backdrop hide-footer>
			<b-row>
				<b-col>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.icon') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.icon" id="popover-target-1" type="text" readonly/>
						<b-popover target="popover-target-1" triggers="hover" placement="bottom" class="bg-dark">
							<a v-for="(i, index) in icons" :key="`icon-${index}`" @click="form.icon=i;$forceUpdate()" style="font-size: 20px; cursor: pointer" size="sm">{{ i }}</a>
						</b-popover>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_uz') }} ({{ form.icon }})</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameUz" type="text"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_ru') }} ({{ form.icon }})</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameRu" type="text"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_en') }} ({{ form.icon }})</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameEn" type="text"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.order') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.orderNumber" type="number"/>
					</b-input-group>
				</b-col>
			</b-row>
			<hr>
			<div class="card-header-actions">
				<b-button @click="createModal =  false" variant="outline-danger" class="mr-3" size="sm">{{ $t('cancel') }}</b-button>
				<b-button @click="save" v-loading="loading" variant="success" size="sm">{{ $t('save') }}</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { BOverlay, BPopover } from 'bootstrapVue2';
import AirCafeCategoryService from "@/views/airCafe/service/category.service";

export default {
	name: "category",
	components: {BOverlay, BPopover},
	data() {
		return {
			items: [],
			search: '',
			create: true,
			createModal: false,
			form: {},
			loading: false,
			icons: ['🍾','🧉','🍹','🍸','🥃','🍷','🥂','🍻','🍺','🧋','🥤','☕️','🍵','🫖','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🎂','🥐','🥯','🍞','🧀','🥞','🧇','🥓','🌭','🍔','🍟','🍕','🫓','🥪','🥙','🧆','🌮','🌯','🫔','🥗','🥘','🍜','🍲','🥮','🥠','🍥','🍤','🦪','🥟','🍢','🍡','🍧','🍨','🍦','🥧','🧁','🍰']
		}
	},
	methods: {
		createForm() {
			this.create = true
			this.form = {}
			this.form.icon = ''
			this.form.nameUz = ''
			this.form.nameRu = ''
			this.form.nameEn = ''
			this.form.orderNumber = ''
			this.form.status = true
			this.createModal = true
		},
		editForm(item) {
			this.create = false
			this.form = Object.assign({}, item)
			this.createModal = true
		},
		async getList() {
			this.loading = true
			await AirCafeCategoryService.list(this.search).then(res => {
				this.items = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async changeStatus(item) {
			this.loading = true
			item.status = !item.status
			await AirCafeCategoryService.changeStatus(item).then(res => {
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
				this.getList();
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async save() {
			if (this.form.nameUz!==''&&this.form.nameRu!==''&&this.form.nameEn!==''&&this.form.orderNumber!=='') {
				this.loading = true
				if (this.create) {
					await AirCafeCategoryService.create(this.form).then(res => {
						this.createModal = false
						this.getList();
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}).finally(f => {
						this.loading = false
					})
				} else {
					await AirCafeCategoryService.update(this.form.id, this.form).then(res => {
						this.createModal = false
						this.getList();
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}).finally(f => {
						this.loading = false
					})
				}
			} else {
				this.$vs.notify({
					title: this.$t('required_error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	watch: {
		'search': {
			handler(e) {
				this.getList();
			}
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>
.width12 {
	width: 8% !important;
}
</style>

<style scoped lang="scss">
.upload-wrapper{
	position: relative;
	overflow: hidden;
	border: 2px solid #e1e1e1;
	height: 200px;
	text-align: center;
}
.upload-wrapper i.fa{
	position: absolute;
	color: #e1e1e1;
	font-size: 50px;
	left: calc(50% - 25px);
	top: calc(50% - 25px)
}
.upload-wrapper input{
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	opacity: 0;
}
.image-wrapper{
	position: relative;
	cursor: pointer;
}
.image-wrapper i.fa{
	position: absolute;
	right: 15px;
	color: #fff;
	top: 0;
	padding: 5px;
	border: 5px solid #08772f;
	background: #4dbd74;
	&.fa-close {
		border: .5px solid red;
		background: lightcoral;
	}
}
</style>
